export const controllerRoutePrefix = "/lux3/v2";
